import React from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons'
import { useHistory } from 'react-router'
import { useAccess } from 'contexts/AccessContext'
import { createRouteParticipantCourseResults } from 'enum/routes'

import Chat from '../../Chat'
import styles from './ChatModal.module.scss'

interface IChatModal {
  show: boolean
  onClose: any
  onSend: any
  courseId: number
  title?: string
  conversationId?: number
  owner: number
}

const ChatModal: React.FC<IChatModal> = ({
  show,
  onClose,
  onSend,
  courseId,
  title,
  owner,
  conversationId = 0,
}) => {
  const history = useHistory()
  const { isAdmin } = useAccess()

  const handleRedirect = () => {
    if (isAdmin()) {
      history.push(
        createRouteParticipantCourseResults({
          userId: `${owner}`,
          courseId: `${courseId}`,
        })
      )
    } else {
      history.push(`/courses/${courseId}/lessons`)
    }
  }

  return (
    <Modal
      show={show}
      size="lg"
      centered
      className={styles.modalContainer}
      onHide={onClose}
    >
      <Modal.Header
        translate="yes"
        closeButton
        className={`p-0 pb-3 d-flex align-items-center`}
      >
        <a onClick={handleRedirect}>
          <h1 className={styles.title}>
            {title || ''}
            <FontAwesomeIcon icon={faExternalLink} />
          </h1>
        </a>
      </Modal.Header>
      <Modal.Body className={'p-0 w-100 h-75'}>
        {show && (
          <Chat
            onSend={onSend}
            courseId={courseId}
            fromModal={true}
            conversationId={conversationId}
          />
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ChatModal
